// const API_URL = process.env.REACT_APP_API_URL;

// /* =============================================================
//    INTERNAL HANDLER — handles:
//    - cookies
//    - refresh flow
//    - retry logic
// ============================================================= */
// const authorizedRequest = async (url: string, options: RequestInit = {}) => {
//   const finalOptions: RequestInit = {
//     credentials: "include",
//     headers: {
//       "Content-Type": "application/json",
//       ...(options.headers || {})
//     },
//     ...options
//   };

//   let response = await fetch(`${API_URL}${url}`, finalOptions);

//   // Handle expired token
//   if (response.status === 401) {
//     console.warn("Token expired → attempting refresh");

//     const refreshRes = await fetch(`${API_URL}/auth/refresh`, {
//       method: "POST",
//       credentials: "include"
//     });

//     // if (!refreshRes.ok) {
//     //   console.warn("Refresh failed → session expired");
//     //   window.dispatchEvent(new Event("auth-session-expired"));
//     //   return response;
//     // }
//     if (!refreshRes.ok) {
//   window.dispatchEvent(new Event("auth-session-expired"));
//   throw new Error("Session expired");
// }

//     // retry original
//     response = await fetch(`${API_URL}${url}`, finalOptions);
//   }

//   return response;
// };

// /* =============================================================
//    PUBLIC REQUEST HANDLER
// ============================================================= */
// const publicRequest = async (url: string, options: RequestInit = {}) => {
//   const finalOptions: RequestInit = {
//     headers: {
//       "Content-Type": "application/json",
//       ...(options.headers || {})
//     },
//     ...options
//   };

//   return fetch(`${API_URL}${url}`, finalOptions);
// };

// /* =============================================================
//    AUTHENTICATED JSON HELPERS
// ============================================================= */
// export const apiGet = async <T = any>(url: string): Promise<T> => {
//   const res = await authorizedRequest(url, { method: "GET" });
//    if (!res.ok) throw new Error(`HTTP ${res.status}`);
//   return res.json();
// };

// export const apiPost = async <T = any>(url: string, body?: any): Promise<T> => {
//   const res = await authorizedRequest(url, {
//     method: "POST",
//     body: JSON.stringify(body ?? {})
//   });
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//   return res.json();
// };

// export const apiPut = async <T = any>(url: string, body?: any): Promise<T> => {
//   const res = await authorizedRequest(url, {
//     method: "PUT",
//     body: JSON.stringify(body ?? {})
//   });
//    if (!res.ok) throw new Error(`HTTP ${res.status}`);
//   return res.json();
// };

// export const apiDelete = async <T = any>(url: string): Promise<T> => {
//   const res = await authorizedRequest(url, {
//     method: "DELETE"
//   });
//   return res.json().catch(() => ({} as T));
// };

// /* =============================================================
//    AUTHENTICATED RAW RESPONSES (for checking status codes)
// ============================================================= */
// export const apiRawGet = (url: string) =>
//   authorizedRequest(url, { method: "GET" });

// // export const apiRawPost = (url: string, body?: any) =>
// //   authorizedRequest(url, {
// //     method: "POST",
// //     body: JSON.stringify(body ?? {})
// //   });
// export const apiRawPost = (url: string, body?: any) => {
//   const isFormData = body instanceof FormData;

//   return authorizedRequest(url, {
//     method: "POST",
//     body: isFormData ? body : JSON.stringify(body ?? {}),
//     headers: isFormData
//       ? undefined // låt browsern sätta multipart boundary
//       : { "Content-Type": "application/json" }
//   });
// };
// export const apiRawPut = (url: string, body?: any) =>
//   authorizedRequest(url, {
//     method: "PUT",
//     body: JSON.stringify(body ?? {})
//   });

// export const apiRawDelete = (url: string) =>
//   authorizedRequest(url, { method: "DELETE" });

// /* =============================================================
//    PUBLIC JSON HELPERS
// ============================================================= */
// export const apiPublicGet = async <T = any>(url: string): Promise<T> => {
//   const res = await publicRequest(url, { method: "GET" });
//   return res.json();
// };

// export const apiPublicPost = async <T = any>(url: string, body?: any): Promise<T> => {
//   const res = await publicRequest(url, {
//     method: "POST",
//     body: JSON.stringify(body ?? {})
//   });
//   return res.json();
// };

// export const apiPublicPut = async <T = any>(url: string, body?: any): Promise<T> => {
//   const res = await publicRequest(url, {
//     method: "PUT",
//     body: JSON.stringify(body ?? {})
//   });
//   return res.json();
// };

// export const apiPublicDelete = async <T = any>(url: string): Promise<T> => {
//   const res = await publicRequest(url, { method: "DELETE" });
//   return res.json().catch(() => ({} as T));
// };

// /* =============================================================
//    PUBLIC RAW RESPONSES (for status codes)
// ============================================================= */
// export const apiPublicRawGet = (url: string) =>
//   publicRequest(url, { method: "GET" });

// export const apiPublicRawPost = (url: string, body?: any) =>
//   publicRequest(url, {
//     method: "POST",
//     body: JSON.stringify(body ?? {})
//   });

// export const apiPublicRawPut = (url: string, body?: any) =>
//   publicRequest(url, {
//     method: "PUT",
//     body: JSON.stringify(body ?? {})
//   });

// export const apiPublicRawDelete = (url: string) =>
//   publicRequest(url, { method: "DELETE" });
const API_URL = process.env.REACT_APP_API_URL;

/* =============================================================
   INTERNAL HANDLER — cookies + refresh + retry + locking
============================================================= */

let refreshPromise: Promise<Response> | null = null;

export const refreshSession = async (): Promise<boolean> => {
  if (!refreshPromise) {
    refreshPromise = fetch(`${API_URL}/Auth/refresh`, {
      method: "POST",
      credentials: "include"
    }).finally(() => {
      refreshPromise = null;
    });
  }

  const refreshRes = await refreshPromise;
  return refreshRes.ok;
};

const authorizedRequest = async (url: string, options: RequestInit = {}) => {
  const isFormData = options.body instanceof FormData;
  const finalOptions: RequestInit = {
    credentials: "include",
    cache: "no-store",
    ...options
  };

  if (!isFormData) {
    finalOptions.headers = {
      "Content-Type": "application/json",
      ...(options.headers || {})
    };
  }

  let response = await fetch(`${API_URL}${url}`, finalOptions);

  if (response.status === 401) {
    const refreshed = await refreshSession();

    if (!refreshed) {
      window.dispatchEvent(new Event("auth-session-expired"));
      throw new Error("Session expired");
    }

    response = await fetch(`${API_URL}${url}`, finalOptions);
  }

  return response;
};

/* =============================================================
   PUBLIC REQUEST HANDLER
============================================================= */

const publicRequest = async (url: string, options: RequestInit = {}) => {
  const isFormData = options.body instanceof FormData;
  const finalOptions: RequestInit = {
    cache: "no-store",
    ...options
  };

  if (!isFormData) {
    finalOptions.headers = {
      "Content-Type": "application/json",
      ...(options.headers || {})
    };
  }

  return fetch(`${API_URL}${url}`, finalOptions);
};

/* =============================================================
   AUTHENTICATED JSON HELPERS
============================================================= */

export const apiGet = async <T = any>(url: string): Promise<T> => {
  const res = await authorizedRequest(url, { method: "GET" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiPost = async <T = any>(url: string, body?: any): Promise<T> => {
  const res = await authorizedRequest(url, {
    method: "POST",
    body: JSON.stringify(body ?? {})
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiPut = async <T = any>(url: string, body?: any): Promise<T> => {
  const res = await authorizedRequest(url, {
    method: "PUT",
    body: JSON.stringify(body ?? {})
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiDelete = async <T = any>(url: string): Promise<T> => {
  const res = await authorizedRequest(url, { method: "DELETE" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json().catch(() => ({} as T));
};

/* =============================================================
   AUTHENTICATED RAW RESPONSES
============================================================= */

export const apiRawGet = (url: string) =>
  authorizedRequest(url, { method: "GET" });

export const apiRawPost = (url: string, body?: any) => {
  const isFormData = body instanceof FormData;

  return authorizedRequest(url, {
    method: "POST",
    body: isFormData ? body : JSON.stringify(body ?? {}),
    headers: isFormData ? undefined : { "Content-Type": "application/json" }
  });
};

export const apiRawPut = (url: string, body?: any) =>
  authorizedRequest(url, {
    method: "PUT",
    body: JSON.stringify(body ?? {})
  });

export const apiRawDelete = (url: string) =>
  authorizedRequest(url, { method: "DELETE" });

/* =============================================================
   PUBLIC JSON HELPERS
============================================================= */

export const apiPublicGet = async <T = any>(url: string): Promise<T> => {
  const res = await publicRequest(url, { method: "GET" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiPublicPost = async <T = any>(url: string, body?: any): Promise<T> => {
  const res = await publicRequest(url, {
    method: "POST",
    body: JSON.stringify(body ?? {})
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiPublicPut = async <T = any>(url: string, body?: any): Promise<T> => {
  const res = await publicRequest(url, {
    method: "PUT",
    body: JSON.stringify(body ?? {})
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const apiPublicDelete = async <T = any>(url: string): Promise<T> => {
  const res = await publicRequest(url, { method: "DELETE" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json().catch(() => ({} as T));
};

/* =============================================================
   PUBLIC RAW RESPONSES
============================================================= */

export const apiPublicRawGet = (url: string) =>
  publicRequest(url, { method: "GET" });

export const apiPublicRawPost = (url: string, body?: any) =>
  publicRequest(url, {
    method: "POST",
    body: JSON.stringify(body ?? {})
  });

export const apiPublicRawPut = (url: string, body?: any) =>
  publicRequest(url, {
    method: "PUT",
    body: JSON.stringify(body ?? {})
  });

export const apiPublicRawDelete = (url: string) =>
  publicRequest(url, { method: "DELETE" });
